<input
    #phoneInput
    class="form-control {{ isInvalid ? 'is-invalid' : '' }} {{ classWidth }}"
    type="tel"
    autocomplete="off"
    [required]="isRequired"
    (blur)="isRequired ? checkIsInvalidRequired() : checkIsInvalid()"
    [id]="id"
    [(ngModel)]="phoneNumber"
    (ngModelChange)="updateAndEmitPhoneNumber()"
    (countrychange)="updateAndEmitPhoneNumber()"
    [disabled]="disabled"
/>
